import { Stack, Typography } from '@mui/material'

interface ContainerTitleProps {
    title: string
    description?: string
}

export const ContainerTitle = ({ title, description }: ContainerTitleProps) => {
    return (
        <Stack spacing={2} sx={{ mb: 3 }}>
            <Typography variant="h3">{title}</Typography>
            {description && (
                <Typography sx={{ fontWeight: 'bold' }}>
                    {description}
                </Typography>
            )}
        </Stack>
    )
}
